import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "Index",
    component: () =>
      import(/* webpackChunkName: "index" */ "../views/Index.vue"),
  },
  {
    path: "/test/:gender",
    name: "Test",
    component: () => import(/* webpackChunkName: "test" */ "../views/Test.vue"),
  },
  {
    path: "/result/:gender",
    name: "Result",
    component: () =>
      import(/* webpackChunkName: "result" */ "../views/Result.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

//全局前置守卫
router.beforeEach(async (to, from, next) => {
  //前往首页
  if (to.path == "/") {
    window.sessionStorage.removeItem("kunqu_test_answer");
    next();
  } else if (
    (to.path == "/test" && from.path != "/") ||
    (to.path == "/result" && from.path != "/test")
  ) {
    if (window.sessionStorage.getItem("kunqu_test_answer")) {
      next();
    } else {
      next("/");
    }
  } else {
    next();
  }
});

export default router;
